import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

/* Don't want to persist this data across sessions, refresh, etc. */

export default {
  actions,
  getters,
  mutations,
  state,
};
